'use client';

import { ContactSupportSection, PageBuilderPage } from '@workspace/widgets';
import { GET_GENERIC_PAGE_QUERY_RESULT } from '@/sanity.types';

export default function ClientAboutUsPage({ page }: { page: GET_GENERIC_PAGE_QUERY_RESULT }) {
  if (!page?._id) return null;

  return (
    <div>
      <PageBuilderPage page={page} />
      <ContactSupportSection locator={{ docId: page._id }} />
    </div>
  );
}
